<template>
  <div class="dutyStatics" ref="dutyStatics">
    <div class="dutyStaticsBar" v-bind:key="i" v-for="(item, i) in dutyStaticsList">
      <div class="inlineBlock bar1">
        <div
          :class="{
            'bar-title': true,
            'bar1-title': true,
            'bar1-title-green':
              item.handleState == 2 || item.handleState == 3 ? true : false,
          }"
        >
          {{ item.typeName }}-{{
            item.metric +
            (item.warnType === 1 ? "超标" : item.warnType === 2 ? "超低" : "")
          }}
        </div>
        <div class="bar-content bar1-content">
          {{ item.deviceName }}<span style="display: block">{{ item.eventTime }}</span>
        </div>
      </div>
      <div class="inlineBlock bar2">
        <div class="bar-title bar2-title">{{ item.metric }}</div>
        <div class="bar-content number bar2-content">
          {{ item.value.toFixed(2) }}<span>{{ item.unit }}</span>
        </div>
      </div>
      <div class="inlineBlock bar3">
        <div class="bar-title bar3-title" :style="getColor(item.handleState)">
          {{ item.handleStateCN }}
        </div>
        <div @click="searchDetail(item)" class="bar-content bar3-content">
          <span>查看详情</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  inject: ["updateEventData"],
  data() {
    //这里存放数据
    return {
      dutyStaticsList: [],
      timer: null,
      dutyStore: [],
    };
  },
  //计算属性 类似于data概念
  computed: {
    getColor() {
      return function (status) {
        let result = {};
        if (status === 0) {
          result = {
            color: "#F5A623",
          };
        } else if (status === 1) {
          result = {
            color: "#F5A623",
          };
        } else if (status === 2) {
          result = {
            color: "#30D594",
          };
        }
        return result;
      };
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.dutyStatics).outerWidth();
    let h = $(that.$refs.dutyStatics).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getData();
    //handleState 处理状态 0 已创建  1 处理中  2 已处理  3 已撤销
    //eventTime
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  //方法集合
  methods: {
    checkStore(list) {
      list.forEach((item) => {
        if (
          $.inArray(item.workTicketNo, this.dutyStore) < 0 /*&&
          (item.handleState === 0 || item.handleState === 1)*/
        ) {
          this.dutyStore.push(item.workTicketNo);
        } else if (
          $.inArray(item.workTicketNo, this.dutyStore) >= 0 /*&&
          (item.handleState === 2 || item.handleState === 3)*/
        ) {
          this.dutyStore.splice($.inArray(item.workTicketNo, this.dutyStore), 1);
        }
      });

      console.log(dutyStore);
    },
    searchDetail(item) {
      this.updateEventData(item);
    },
    async getData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let that = this;
      let getListParamPageUrl = CONFIG.requestName + this.$apiOpt.getListParamPage;
      this.$apiUtils
        .get(getListParamPageUrl, {
          customerId: this.$store.state.customerId,
          pageNum: 1,
          pageSize: 100,
        })
        .then(function (data) {
          that.dutyStaticsList = data.list;
          //that.checkStore(data.list);
          that.dutyStaticsList.forEach((item) => {
            item.eventTime = that.$moment(item.eventTime).format("MM-DD HH:mm");
            item.handleStateCN = "";
            if (item.handleState === 0) {
              item.handleStateCN = "已创建";
            } else if (item.handleState === 1) {
              item.handleStateCN = "处理中";
            } else if (item.handleState === 2) {
              item.handleStateCN = "已处理";
            } else if (item.handleState === 3) {
              item.handleStateCN = "已撤销";
            }
          });
          that.$forceUpdate();
          // console.log(that.dutyStaticsList);
          //alert(2222);
        });

      that.timer = setTimeout(() => {
        that.getData();
      }, 60000);
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.dutyStatics {
  position: absolute;
  height: 720px;
  width: 100%;
  margin-top: 55px !important;
  padding: 10px 32px 20px 32px !important;
  pointer-events: all;
  overflow: auto;
  .dutyStaticsBar {
    position: relative;
    width: 100%;
    display: flex;
    background: rgba(0, 0, 0, 0.8);
    margin: 10px 0;
    border: 1px solid #8badff;
    .bar1 {
      width: calc(100% - 300px);
    }
    .bar2 {
      width: 160px;
    }
    .bar3 {
      width: 100px;
    }
  }

  .bar-title {
    display: block;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }
  .bar-content {
    display: block;
    height: 80px;
    padding: 10px 10px;
  }
  .bar1-title {
    font-family: "normalFont";
    font-size: 18px;
    color: #ff7373;
    padding: 0px 15px;
    border-right: 1px solid #99c0ff;
    border-bottom: 1px solid #99c0ff;
    span {
      float: right;
      color: #c8dde1;
    }
  }

  .bar1-title-green {
    color: #30d594 !important;
  }

  .bar1-content {
    color: #c6c6c6;
    font-family: "normalFont";
    font-size: 18px;
    padding: 10px 15px;
    border-right: 1px solid #99c0ff;
  }

  .bar2-title {
    font-family: "normalFont";
    font-size: 18px;
    color: #99c0ff;
    padding: 0px 15px;
    border-right: 1px solid #99c0ff;
    border-bottom: 1px solid #99c0ff;
    text-align: center;
  }

  .bar2-content {
    color: #ffffff;
    font-family: "normalFont";
    font-size: 26px;
    padding: 15px 15px;
    border-right: 1px solid #99c0ff;
    text-align: center;

    span {
      display: block;
      font-size: 16px;
      line-height: 16px;
      font-family: "normalFont" !important;
      color: #c6c6c6;
    }
  }

  .bar3-title {
    color: #c6c6c6;
    font-family: "normalFont";
    font-size: 20px;
    padding: 10px 15px;
    text-align: center;
    background: linear-gradient(
      225deg,
      rgba(108, 151, 255, 0.31) 0%,
      rgba(58, 116, 255, 0.33) 100%,
      #0049fa 100%
    );
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    height: 62px;
    width: 140px;
    position: relative;
  }

  .bar3-content {
    color: #c6c6c6;
    font-family: "normalFont";
    font-size: 20px;
    padding: 15px 15px;
    text-align: center;
    background: linear-gradient(
      225deg,
      rgba(108, 151, 255, 0.31) 0%,
      rgba(58, 116, 255, 0.33) 100%,
      #0049fa 100%
    );
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    height: 62px;
    width: 140px;
    color: #99f5ff;
    position: relative;
    cursor: pointer;
    span {
      //text-decoration: underline;
    }
  }
}
</style>
